import Cookies from 'universal-cookie';
const cookies = new Cookies()

export const setCookieIfAlias = () => {
    const originPathParams = window.location.href.split('/')
    const referrerPathParams = window.document.referrer.split('/')
    if (originPathParams.indexOf('contrats') > 1 && referrerPathParams.indexOf('contrats') > 1) {
      const originPermalink = originPathParams[originPathParams.indexOf('contrats') + 1]
      const referrerPermalink = referrerPathParams[referrerPathParams.indexOf('contrats') + 1]
      if (originPermalink !== referrerPermalink) {
        cookies.set(`origin-${originPermalink}`, referrerPermalink, {path: '/', domain: process.env.REACT_APP_COOKIES_ALL_SUBDOMAIN})
      } else {
        // In case the previous page is a landing page and is not the alias landing
        if (originPathParams.length === 6 && referrerPathParams.length === 6 && originPathParams[5] === 'creer' && referrerPathParams[5] === '') {
          if (cookies.get(`origin-${originPermalink}`)) {
              cookies.remove(`origin-${originPermalink}`, {path: '/', domain: process.env.REACT_APP_COOKIES_ALL_SUBDOMAIN})
            }
        }
      }
    }
}



// WEBPACK FOOTER //
// ./src/manager/aliasManager.js